import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';


const Note = ( { aid, uid, meta, notes, setCurrent } ) => {
    let params = useParams();
    const [ n, setNote ] = useState( {
        details: {},
        assoc: []
    } );
    
    useEffect( () => {
        setCurrent( params.nid );
    }, [ params.nid, setCurrent ] );

    useEffect( () => {
        console.log( notes[params.nid] );
        setNote( prev => {
            return {
                ...prev,
                details: notes[params.nid],
                assoc: notes[params.nid].assoc
            }
        } );
    }, [ params.nid, notes ] );

    useEffect( () => {
        console.log( 'n:', n );
    }, [ n ] );

    useEffect( () => {
        document.title = `Third Floor - ${n.details.name}`;
    }, [ n.details.name ] );

    return (
        <TFObject key={params.nid} objType='note' obj={n} oid={params.nid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
    )
}

const mapProps = ( state ) =>( {
    aid: state.user.aid,
    uid: state.user.email,
    meta: state.user.meta.note,
    notes: state.notes.byId
} );

const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.loans.setCurrent
} );

export default connect( mapProps, mapDispatch )( Note );